import {USER_DETAILS } from "../constants/constants";

export const getUserDetails = () => {
  const userDetails = localStorage.getItem(USER_DETAILS);
  return JSON.parse(userDetails || "null");
};